import cx from 'classnames'
import Styles from './FrameEmptyState.module.scss'
import { FrameEmptyStateProps } from './Types'
import { track } from '@tldraw/tldraw'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Images } from 'blaze-ui/icons'
import { Button } from 'blaze-ui/Button'
import { observer } from 'mobx-react-lite'
import { ShapeOverlay } from '../ShapeOverlay/ShapeOverlay'
import { useRootStore } from 'stores/RootStore'
import { useEditor } from 'components/VisualStudioPlayground/VisualEditorContext'
import { useResizeObserver } from '@react-hookz/web'
import { useRef, useState } from 'react'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { BackgroundsDrawer } from 'components/Design/BackgroundsTab/BackgroundsDrawer/BackgroundsDrawer'

export const FrameEmptyState = track(
  observer(({ shape }: FrameEmptyStateProps) => {
    const { designStore, drawersStore } = useRootStore()
    const editor = useEditor()
    const zoom = editor.getZoomLevel()
    const contentRef = useRef<HTMLDivElement | null>(null)
    const [contentSize, setContentSize] = useState({ width: Infinity, height: Infinity })
    const isVisible = shape.props.w * zoom > contentSize.width * 1.2 && shape.props.h * zoom > contentSize.height * 1.2
    const { isMobile } = useResponsiveDesign()

    useResizeObserver(contentRef, (entry) => {
      const height = entry.borderBoxSize[0].blockSize
      const width = entry.borderBoxSize[0].inlineSize
      setContentSize({ width, height })
    })

    const onPress = () => {
      if (isMobile) {
        drawersStore.openDrawer(BackgroundsDrawer)
        return
      }

      designStore?.openTab('backgrounds')
    }

    return (
      <ShapeOverlay className={cx(Styles.frameEmptyState, { [Styles.hidden]: !isVisible })} shape={shape}>
        <div className={Styles.content} ref={contentRef}>
          <div className={Styles.message}>
            <Images size={30} />
            <Heading level={3} color="var(--dark-15)">
              The background of this design is white
            </Heading>
          </div>
          <div className={Styles.buttonContainer}>
            <Button variant="tertiary" size="sm" onPress={onPress}>
              Change Background
            </Button>
          </div>
        </div>
      </ShapeOverlay>
    )
  }),
)
